import { createAction } from 'redux-actions';
const actionKey = 'WATCH_SUGGESTIONS';
export const unsuggestUser = createAction(`${actionKey}.UNSUGGEST.USER`, (payload)=>payload);
